import cx from 'classnames';

import { TextBlock, TTextProps } from '../common';

import styles from './InputMessage.module.scss';
import { TStatus } from '@skillarea/lib-shared';

export const InputMessage = ({
  className,
  line = '100',
  status,
  ...props
}: { status?: TStatus } & TTextProps) => {
  return (
    <TextBlock
      {...props}
      className={cx(styles.inputMessage, className)}
      color={status ?? props.color}
      line={line}
    />
  );
};
